import { useState, useEffect } from "react";

import { Button, Input, Modal } from "reactstrap";

const RenameModal = ({ open, handleClose, item, onSave }) => {
  const [name, setName] = useState("");

  const handleNameChange = (e) => setName(e.target.value);

  useEffect(() => {
    if (item) {
      setName(item.data.Title);
    }
  }, [item]);

  if (!item) return null;

  return (
    <Modal className="modal-dialog-centered" isOpen={open} toggle={handleClose}>
      <div className="modal-header pb-0">
        <h5 className="modal-title" id="exampleModalLabel">
          Renaming "{item.data.Title}"
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body pt-0 pb-0">
        <div className="p-2">
          <h5 style={{ width: 100, paddingTop: 10 }}>New Name</h5>
          <Input
            value={name}
            placeholder="Enter new name"
            onChange={handleNameChange}
          />
        </div>
      </div>
      <div className="modal-footer">
        <Button
          color="secondary"
          data-dismiss="modal"
          type="button"
          onClick={handleClose}
        >
          Close
        </Button>
        <Button
          color="primary"
          disabled={!name || name === item.data.Title}
          onClick={() => {
            onSave(name, item.id);
            handleClose();
          }}
        >
          Rename
        </Button>
      </div>
    </Modal>
  );
};

export default RenameModal;
